export const wrapPageElement = ({ element }) => element;